import { useEffect, useRef, useState } from 'react'

import classNames from 'classnames'

import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import CategoryNavigation from '~/components/blocks/CategoryNavigation/CategoryNavigation'
import { useInPageNavContext } from '~/contexts/InPageNavContext'
import type { ArticlesPageData } from '~/utils/articles/getArticlesPageProps'

import styles from './PressNavigation.module.css'

export interface PressNavigationProps {
  featuredCategories: ArticlesPageData['featuredCategories']
  articleArtists?: any
  testID?: string
  showLogo?: boolean
  selectedSlug?: string
  selectedArtistName?: string
  noBorder?: boolean
  marginTop?: boolean
  inPage?: boolean
}

export default function PressNavigation({
  featuredCategories,
  testID,
  selectedSlug,
  marginTop = false,
  noBorder = false,
  inPage = true,
}: PressNavigationProps) {
  const [isElementTouchingTop, setIsElementTouchingTop] =
    useState<boolean>(false)

  const { mainHeaderVisible } = useInPageNavContext()

  const filtersRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      const element = filtersRef.current
      if (element) {
        const elementRect = element.getBoundingClientRect()
        const topValue = mainHeaderVisible ? (inPage ? 76 : 54) : 0
        const isTouchingTop = elementRect.top <= topValue
        setTimeout(() => {
          setIsElementTouchingTop(isTouchingTop)
        }, 10)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <div
        className={classNames(styles.base, {
          [styles.stuck]: isElementTouchingTop,
          [styles.mergeNavInPage]: inPage && mainHeaderVisible,

          [styles.mergeNav]: !inPage && mainHeaderVisible,

          [styles.noBorder]: noBorder,
          [styles.baseWithMargin]: marginTop,
        })}
        data-testid={testID}
        ref={filtersRef}
      >
        {isElementTouchingTop}
        <Container gutters={gutterTypes.always} cssClass={styles.container}>
          <div className={classNames(styles.inner)}>
            <div className={classNames(styles.scroller)}>
              <div className={classNames(styles.articleFilters)}>
                <CategoryNavigation
                  featuredCategories={featuredCategories}
                  selectedSlug={selectedSlug}
                  hideArtistFilter
                  categorySlug="press"
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}
